import { Typography } from "@mui/material";

export const SummaryTitle = ({ title }) => {
  return <Typography sx={{ fontSize: "20px", fontWeight: 700, lineHeight: "24px", marginBottom: "20px" }}>{title}</Typography>;
};
